<div class="modulo modulo-chamada">
    <div class="modulo-content">
        <div class="container">
            <h2 class="wow slideInDown" data-wow-delay="0.5s">{{data.titulo}}</h2> 
            <h3 class="wow slideInUp">{{data.subtitulo}}</h3>
        </div>
        <div class="content-images" *ngIf="data.images.length > 0">
            <div #slider class="images">
                <div *ngFor="let i of data.images;" class="item">
                    <img [src]="i.imagem" [alt]="i.titulo" width="100%" />
                </div>
            </div>
            <div class="slide-navigate-item prev template-2" (click)="prev()">
                <div class="content">
                    <i class="material-icons">navigate_before</i>
                </div>
            </div>
            <div class="slide-navigate-item next template-2" (click)="next()">
                <div class="content">
                    <i class="material-icons">navigate_next</i>
                </div>
            </div> 
        </div>
    </div>    
</div>    